module.exports = __webpack_public_path__ + "static/media/cough_function.4e122ee6.png";